module.exports = __webpack_public_path__ + "static/img/10012.0fe171f9.png";